import React, { useEffect, useRef, useState } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import '@mdxeditor/editor/style.css'
import {
    diffSourcePlugin,
    DiffSourceToggleWrapper,
    headingsPlugin,
    linkPlugin,
    listsPlugin,
    MDXEditor,
    quotePlugin,
    tablePlugin,
    thematicBreakPlugin,
    toolbarPlugin,
} from '@mdxeditor/editor'

import Feedback from '@softwaredev_cegeka/stix-form/dist/components/Feedback'
import Label from '@softwaredev_cegeka/stix-form/dist/components/Label'

// Styles
import styles from './richTextField.module.scss'

RichTextField.propTypes = {
    content: PropTypes.string,
    label: PropTypes.string.isRequired,
    required: PropTypes.bool,
}

function RichTextField(props) {
    const {
        content = '',
        label,
        required = false,
        onMarkdownChange,
        error,
    } = props
    const [value, setValue] = useState(content ?? '')
    const editorRef = useRef()

    useEffect(() => {
        const nextValue = content ?? ''
        setValue(prevValue => {
            if (prevValue === nextValue) {
                return prevValue
            }
            return nextValue
        })

        if (editorRef?.current?.setMarkdown) {
            editorRef.current.setMarkdown(nextValue)
        }
    }, [content])

    return (
        <>
            <Label required={required} label={label} htmlFor={label} />
            <MDXEditor
                aria-labelledby={label}
                ref={editorRef}
                viewMode={'source'}
                className={cx(styles.editor, {
                    [styles.hasError]: error?.length > 0,
                })}
                markdown={value}
                onChange={setValue}
                onBlur={() => onMarkdownChange(value)}
                plugins={[
                    headingsPlugin(),
                    listsPlugin(),
                    quotePlugin(),
                    linkPlugin(),
                    tablePlugin(),
                    thematicBreakPlugin(),
                    // the viewMode parameter lets you switch the editor to diff or source mode.
                    // you can get the diffMarkdown from your backend and pass it here.
                    diffSourcePlugin({
                        viewMode: 'source',
                        readOnlyDiff: true,
                    }),
                    toolbarPlugin({
                        toolbarContents: () => <DiffSourceToggleWrapper />,
                    }),
                ]}
            />
            {error?.length > 0 && (
                <Feedback feedbackType="invalid" feedback={error[0]} />
            )}
        </>
    )
}

export default RichTextField
